(function() {
    // Find the container and get the data attribute
    const productStitchingContainer = document.getElementById('product-stitching-container');
    const productGroupId = productStitchingContainer.dataset.group;
    const productHandle = productStitchingContainer.dataset.handle;
    let isLoaded = false;
    
    if (productGroupId) {
        const apiToken = window.theme.product_stitching.app_token;
        
        // Create the GraphQL query
        const query = `
            query Swatches($namespace: String = "custom", $key: String = "product_stitching", $value: String = "${productGroupId}") {
              collection(handle: "all") {
                handle
                products(first: 20, 
                  filters: {
                    productMetafield: {
                      namespace: $namespace,
                      key: $key,
                      value: $value
                  }
                }) {
                  edges {
                    node {
                      handle
                      title
                      onlineStoreUrl
                      availableForSale
                      featuredImage {
                        url
                      }
                      variants(first: 20) {
                        edges {
                          node {
                            title
                          }
                        }
                      }
                      metafield: metafield(namespace: $namespace, key: $key){
                        value
                        description
                        type
                      }
                      colour_group: metafield(namespace: "filters", key: "colour_group"){
                        value
                        description
                        type
                      }
                    }
                  }
                }
              }
            }
        `;
        
        fetch(`${window.theme.product_stitching.shop_url}/api/2024-04/graphql.json`, {
            method: "POST",
            headers: {
                'X-Shopify-Storefront-Access-Token': apiToken,
                'Content-Type': 'application/graphql'
            },
            body: query
        })
        .then(response => response.json())
        .then(data => {
            const productStitchingContainerList = document.querySelectorAll('.product-stitching-container');
            let products = data.data.collection.products.edges.map(x => x.node);
            let colorSwatchesHTML = '';
            let containerHTML = '';
            let currentColorName = '';
            if (products.length > 1) {
                for (let i = 0; i < products.length; i++) {
                    let product = products[i];
                    let currentClass = (product.handle === productHandle) ? ' is-selected' : '';
                    if (!product.availableForSale) {
                        currentClass += ' is-sold-out';
                    }
                    let variantNames = product.variants.edges.map(x => x.node);
                    if (currentColorName === '' && product.handle === productHandle) {
                        currentColorName = variantNames[0].title.split(' / ')[0] || '';
                    }
                    const swatchLink = product.onlineStoreUrl ?? 'javascript:void(0)';
                    const colourGroupValue = product.colour_group && product.colour_group.value ? product.colour_group.value.toLowerCase().replace(/\s+/g, '-') : '';
                    if (colourGroupValue === '') {
                        colorSwatchesHTML += `<a href="${swatchLink}" class="o-swatches__swatch-option ${currentClass}">
                            <figure class="image-lazy o-swatches__swatch-option-image image-lazy--contain"><img
                                loading="lazy" src="${product.featuredImage.url}" alt="${product.title}" width="28" height="28"/></figure>
                        </a>`;
                    } else {
                        colorSwatchesHTML += `<a href="${swatchLink}" class="o-swatches__swatch-option s-swatch--${colourGroupValue} s-pdp-swatch--${colourGroupValue} ${currentClass}">
                            <span class="o-swatches__swatch-option--soldout"></span>
                        </a>`;
                    }                    
                }
                
                console.log(currentColorName);
                if (colorSwatchesHTML !== '') {
                    containerHTML = `<div class="c-product-template__details-swatch-message">
                            <div class="o-swatches">
                              <div class="o-swatches__swatch is-color">
                                <div class="o-swatches__header-wrapper">
                                    <p class="o-swatches__swatch-header">                  
                                      <span class="o-swatches__swatch-header-name">Colour:</span>
                                      <span class="o-swatches__swatch-header-value">${currentColorName}</span>
                                    </p>
                                </div>
                                <div class="o-swatches__swatch-options">
                                    ${colorSwatchesHTML}
                                </div>
                            </div>
                        </div>
                    </div>`;
                }
                if (productStitchingContainerList.length  && !isLoaded) {
                    Array.from(productStitchingContainerList).forEach((productStitchingContainer) => {
                        productStitchingContainer.innerHTML = containerHTML;
                    });
                    isLoaded = true;
                }
            } else {
                productStitchingContainerList.forEach((productStitchingContainer) => {
                    productStitchingContainer.style.display = 'none';
                });
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }
})();
